// from prosemirror-schema-basic
export var code = {
    parseDOM: [{ tag: 'code' }, { style: 'font-family=monospace' }],
    toDOM: function () { return ['code', 0]; },
};
